import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage.vue'
import DAutoPage from '../views/DAutoPage.vue'

Vue.use(VueRouter)

const BASE_URL = 'https://elttec.com'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: {
      title: 'ELTTEC 易伦特科技 - 智能数字化解决方案 | 船舶服务管理·企业运营·数字自动化',
      description: 'ELTTEC 易伦特科技专注企业数字化转型，提供SSMS船舶服务管理系统、EOM企业运营管理平台、RPA机器人流程自动化、DAuto数字自动化产线集成四大核心产品线，为航运、制造、贸易等行业提供一站式智能解决方案。',
      keywords: 'ELTTEC,易伦特科技,数字化,自动化,智能制造,船舶服务管理,企业运营管理,SSMS,EOM,RPA,DAuto,航运数字化,供应链管理,工业4.0',
      ogType: 'website',
      ogImage: 'og-image.png',
      canonical: `${BASE_URL}/`
    }
  },
  {
    path: '/digital-automation',
    name: 'DAuto',
    component: DAutoPage,
    meta: {
      title: 'DAuto 数字自动化产线集成 | 设备互联·流程控制·IT-OT融合 - ELTTEC 易伦特科技',
      description: 'ELTTEC DAuto数字自动化产线集成方案，实现设备互联与数据采集、生产流程自动化控制、IT-OT深度融合、全生命周期追溯、柔性制造管理和智能优化决策，打通数字化管理系统与自动化产线设备，构建立体化智能工厂。',
      keywords: 'DAuto,数字自动化,产线集成,IT-OT融合,设备互联,数据采集,智能制造,MOM,SCADA,PLC,工业自动化,柔性制造,质量追溯',
      ogType: 'product',
      ogImage: 'og-image-dauto.png',
      canonical: `${BASE_URL}/digital-automation`
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) {
      return { selector: to.hash, behavior: 'smooth' }
    }
    return { x: 0, y: 0 }
  }
})

export default router
